/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Unblocked_ToastInputs */



/**
* | output |
* | --- |
* | "An administrator approved this chat. You can continue the conversation." |
*
* @param {Chat_Unblocked_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_unblocked_toast = /** @type {((inputs?: Chat_Unblocked_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Unblocked_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Administrator hat diesen Chat freigegeben. Sie können das Gespräch fortsetzen.")
	return /** @type {LocalizedString} */ ("An administrator approved this chat. You can continue the conversation.")
});